module.exports = "/_next/static/images/vida-9cd2b409b5a3aef045267d944ac15247.svg";